import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import validator from 'validator';
import styles from './style.css';
import Captcha from './Captcha';

const validate = values => {
  const errors = {};
  if (!values.oldEmailAddress) {
    errors.oldEmailAddress = 'This field is required';
  } else if (!validator.isEmail(values.oldEmailAddress)) {
    errors.oldEmailAddress = 'The value is not a valid email address';
  }
  if (!values.newEmailAddress) {
    errors.newEmailAddress = 'This field is required';
  } else if (!validator.isEmail(values.newEmailAddress)) {
    errors.newEmailAddress = 'The value is not a valid email address';
  }
  if (!values.captcha) {
    errors.captcha = 'The captcha is not valid';
  }
  return errors;
};

const emailField = field => {
  return (
    <div>
      <input
        {...field.input}
        type={field.type || 'text'}
        maxLength={field.maxLength}
        className={`${styles['input-email-style']} ${
          field.className
        } form-control ${styles['input-style']}`}
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck="false"
        disabled={field.isDisabled}
        placeholder="Email Address"
      />
      <small className={styles.error}>
        {field.meta.touched ? field.meta.error : ''}
      </small>
    </div>
  );
};

let ConfirmEmailModal = class confirmEmailModal extends React.Component {
  render() {
    const { show, onHide, handleSubmit, resetCaptcha } = this.props;
    const modalStyle = { zIndex: 1053 };
    return (
      <div className={`${styles['modal-container']}`}>
        <Modal
          show={show}
          style={modalStyle}
          dialogClassName={`modal-dialog ${styles.dialog}`}
        >
          <Modal.Body className={`${styles.modalContent}`}>
            <form onSubmit={handleSubmit} className={`${styles['email-form']}`}>
              <div className={`${styles['container-email-form']} col-md-12`}>
                <div className={`col-md-12  text-center`}>
                  <img
                    src={require('assets/images/register-empelove.png')}
                    className={`${styles['register-empelove']}`}
                    height="100px"
                  />
                </div>
                <div
                  className={`${
                    styles['container-description']
                  } col-md-10 text-center`}
                >
                  <span className={`${styles['to-start-using-moka']}`}>
                    To start using Moka, click Resend Email to get a
                    verification link.
                  </span>
                  <br />
                  <span className={`${styles['to-start-using-moka']}`}>
                    Once you click Resend button, you'll be forced to log out to
                    complete the process.
                  </span>
                </div>
                <div
                  className={`col-md-10 ${styles['input-email-modal']} ${
                    styles['float-center']
                  }`}
                >
                  <Field
                    component={emailField}
                    name="oldEmailAddress"
                    className={`show emailInput`}
                    maxLength="50"
                    isDisabled
                  />
                  <Field
                    component={emailField}
                    name="newEmailAddress"
                    className={`hide emailInput`}
                    maxLength="50"
                  />
                </div>
                <div
                  className={`col-md-10 ${styles['input-captcha-modal']} ${
                    styles['float-center']
                  }`}
                >
                  <center className={`${styles['margin-bottom-30']}`}>
                    <Field
                      component={Captcha}
                      name="captcha"
                      reset={resetCaptcha}
                    />
                  </center>
                </div>
                <div
                  className={`col-md-10 ${styles['input-email-button']} ${
                    styles['float-center']
                  }`}
                >
                  <button className="btn btn-primary btn-block" type="submit">
                    Resend Email
                  </button>
                </div>
                <div
                  className={`col-md-10 ${styles['input-email-button']} ${
                    styles['float-center']
                  }`}
                >
                  <button
                    className="btn btn-default btn-block"
                    type="button"
                    onClick={onHide}
                  >
                    Close
                  </button>
                </div>
              </div>
            </form>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
};

ConfirmEmailModal.propTypes = {
  registrationForm: PropTypes.object,
  dispatch: PropTypes.func,
  data: PropTypes.object,
  onSubmit: PropTypes.func,
  error: PropTypes.object,
  currentlySending: PropTypes.bool,
};

ConfirmEmailModal = reduxForm({
  form: 'confirmEmailModalForm',
  touchOnBlur: false,
  touchOnChange: true,
  validate,
})(ConfirmEmailModal);

function select(state) {
  return {
    data: state,
  };
}

export default connect(select)(ConfirmEmailModal);
